// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.transi",
    name: "Transi",
    homepage: "https://www.transi.io/",
    image_id: "a567089d-69d5-47f6-fd99-db47a448ab00",
    app: {
        browser: "https://www.transi.io/TransiWallet",
        ios: "https://apps.apple.com/us/app/transi-chat/id1662471884",
        android: "https://www.transi.io/TransiWallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "transi://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map